import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Target, Rocket, TrendingUp, ArrowRight } from 'lucide-react';
const steps = [{
  number: 1,
  icon: FileText,
  title: 'Analizamos Tu Reporte',
  description: 'Analizamos tu reporte de credito completo, identificamos errores, cuentas negativas y oportunidades de mejora para mejorar tu perfil.'
}, {
  number: 2,
  icon: Target,
  title: 'Determinamos Tu Plan',
  description: 'Creamos un plan totalmente personalizado para ti. Definimos metas claras, prioridades y el camino mas eficiente.'
}, {
  number: 3,
  icon: Rocket,
  title: 'Ejecutamos las Estrategias',
  description: 'Realizamos todas las estrategias trazadas y te brindamos actualizacion de cada paso que damos.'
}, {
  number: 4,
  icon: TrendingUp,
  title: 'Obtienes Resultados',
  description: 'Mejoras reales en el menor tiempo posible. Con tu nuevo perfil, te abrimos las puertas al financiamiento que mereces.'
}];
export function Process() {
  return <section id="proceso" className="py-20 md:py-24 bg-black px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-178" data-mp="19n260z65bed8">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-179" data-mp="10rvx3rbkwg6h">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-180" data-mp="vtue16e5kgv0">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-181" data-mp="cvi43iff32yd">
            Nuestro Proceso
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-182" data-mp="278q03df4pkll">
            Resultados en{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-183" data-mp="2qcbh7kvk1959">
              4 Simples Pasos
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-184" data-mp="2herc20ukmspd">
            Un proceso probado, diseñado para transformar tu credito y
            desbloquear financiamiento.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-16" data-id="element-185" data-mp="3e2xc0agjswxb">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index * 0.12,
          ease: [0.16, 1, 0.3, 1]
        }} className={`relative flex flex-col items-center text-center p-8 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border transition-all duration-500 ${step.number === 2 ? 'border-amber-500/40 shadow-lg shadow-amber-500/10' : 'border-white/[0.08] hover:border-amber-500/20'}`} data-id="element-186" data-mp="302cs1aywcv28" data-mpi={index}>
              {/* Icon tile with number badge */}
              <div className="relative mb-8" data-id="element-187" data-mp="ye8ljrqese26">
                <div className="h-20 w-20 rounded-2xl bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30" data-id="element-188" data-mp="yfjo5o84bfrp">
                  <step.icon className="h-9 w-9 text-black" strokeWidth={2} data-id="element-189" data-mp="17eolwsbuv52t" />
                </div>
                <div className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-black border border-amber-500/40 flex items-center justify-center" data-id="element-190" data-mp="jokiom2kx7cc">
                  <span className="text-xs font-bold bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-191" data-mp="eo6ljz2inht3">
                    {step.number}
                  </span>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-4" data-id="element-192" data-mp="12bfpu4aibtsd">
                {step.title}
              </h3>
              <p className="text-white/50 font-light leading-relaxed text-[15px]" data-id="element-193" data-mp="172e9ndupfa0d">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex justify-center" data-id="element-194" data-mp="1g1j52bayyn8b">
          <a href="https://calendly.com/vantixcredit/diagnostico-de-credito" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-10 py-4 rounded-full transition-all text-base shadow-2xl shadow-amber-500/30" data-id="element-195" data-mp="3ru7mjs6ml0lf">
            Comienza Tu Proceso Ahora
            <ArrowRight className="h-4 w-4" data-id="element-196" data-mp="2rwd14g2agas7" />
          </a>
        </motion.div>
      </div>
    </section>;
}